export const getFiles = async (url?: string) => {
	try {
		if (url) {
			const res = await fetch(url);
			return await res.blob();
		}
	} catch (err) {
		return "";
	}
};
